import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import Manifesto from "@/components/Manifesto";
import Pillars from "@/components/Pillars";
import Marquee from "@/components/Marquee";
import Work from "@/components/Work";
import Finale from "@/components/Finale";
import Cursor from "@/components/Cursor";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.085, wheelMultiplier: 1, smoothWheel: true }}>
      <div className="App bg-[#050505] text-[#f2f0e6]" data-testid="portfolio-root">
        <div className="grain" aria-hidden="true" />
        <Cursor />
        <Nav />
        <main>
          <Hero />
          <Stats />
          <Manifesto />
          <Pillars />
          <Marquee />
          <Work />
          <Finale />
        </main>
        <Toaster theme="dark" position="bottom-right" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
